import * as actionTypes from '../actionTypes';
import { DeviceCommandFilterActions, DeviceCommandsFilterState } from 'redux/types/deviceCommandFilterMode.';

const initialState: DeviceCommandsFilterState = {
    selectedSelfRenew: undefined,
    filterModal: false,
    schedule: undefined,
    currentSchedule: undefined,
    filterReplacementDate: undefined,
    deviceRebootDate: undefined,
    deviceFirmwareData: undefined,
    isApplyClicked: false,
    forceFilterCommandModal: false,
};

export const DeviceCommandFilterReducer = (
    state = initialState,
    action: DeviceCommandFilterActions,
): DeviceCommandsFilterState => {
    switch (action.type) {
        case actionTypes.SET_SELECTED_SELF_RENEW:
            return {
                ...state,
                selectedSelfRenew: action.payload,
            };
        case actionTypes.REMOVE_SELECTED_SELF_RENEW:
            return {
                ...state,
                selectedSelfRenew: undefined,
            };
        case actionTypes.SET_FILTERS_MODAL:
            return {
                ...state,
                filterModal: action.payload,
            };
        case actionTypes.SET_SELECTED_SCHEDULE:
            return {
                ...state,
                schedule: action.payload,
            };
        case actionTypes.REMOVE_SELECTED_SCHEDULE:
            return {
                ...state,
                schedule: undefined,
            };
        case actionTypes.SET_CURRENT_SCHEDULE:
            return {
                ...state,
                currentSchedule: action.payload,
            };
        case actionTypes.REMOVE_CURRENT_SCHEDULE:
            return {
                ...state,
                currentSchedule: undefined,
            };
        case actionTypes.SET_FILTER_REPLACEMENT_DATE:
            return {
                ...state,
                filterReplacementDate: action.payload,
            };
        case actionTypes.REMOVE_FILTER_REPLACEMENT_DATE:
            return {
                ...state,
                filterReplacementDate: undefined,
            };
        case actionTypes.SET_DEVICE_REBOOT_DATE:
            return {
                ...state,
                deviceRebootDate: action.payload,
            };
        case actionTypes.REMOVE_DEVICE_REBOOT_DATE:
            return {
                ...state,
                deviceRebootDate: undefined,
            };
        case actionTypes.SET_FIRMWARE_DATA:
            return {
                ...state,
                deviceFirmwareData: action.payload,
            };
        case actionTypes.REMOVE_FIRMWARE_DATA:
            return {
                ...state,
                deviceFirmwareData: undefined,
            };
        case actionTypes.IS_APPLY_CLICKED:
            return {
                ...state,
                isApplyClicked: action.payload,
            };
        case actionTypes.REMOVE_ALL_FILTERS:
            return {
                ...state,
                ...initialState,
                isApplyClicked: state.isApplyClicked,
            };
        case actionTypes.CHANGE_FORCE_FILTER_COMMAND_MODAL:
            return {
                ...state,
                forceFilterCommandModal: action.payload,
            };
        default:
            return state;
    }
};
